import type { IconData } from '@stacksjs/iconify-core'

export const callCenterSupportService: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M1.984 14c0-5.523 4.478-10 10-10h.57a3 3 0 0 1 2.785 1.886l2.466 6.165a4 4 0 0 1-.886 4.314l-3.076 3.077c-.493.493-.701 1.21-.499 1.878a20.05 20.05 0 0 0 13.32 13.32c.668.203 1.385-.005 1.879-.498l3.076-3.077a4 4 0 0 1 4.314-.885l6.166 2.466a3 3 0 0 1 1.885 2.785V36c0 5.523-4.477 10-10 10h-.5C16.374 46 2.45 32.358 1.996 15.358a.02.02 0 0 0-.006-.013a.02.02 0 0 1-.006-.013zM43.5 11h-7.273a.727.727 0 0 1-.547-1.206l6.614-7.56a.688.688 0 0 1 1.206.454zm0 0h2m-2 0v3\"/><path d=\"M31.5 14h-8v-1.705a3 3 0 0 1 1.797-2.748l4.452-1.948A2.922 2.922 0 0 0 28.578 2H26.5a3 3 0 0 0-2.83 2\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default callCenterSupportService
